module.exports = __webpack_public_path__ + "img/popup_white.89620959.png";